module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('m-header', {
    attrs: {
      "title": _vm.data.activity_name
    }
  }), _vm._v(" "), _c('header', [_c('img', {
    staticClass: "img-block",
    attrs: {
      "src": _vm.data.adv_image,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "discribe"
  }, [_c('h1', [_vm._v(_vm._s(_vm.data.activity_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.data.activity_desc))])]), _vm._v(" "), _c('m-list', {
    attrs: {
      "list": _vm.data.itemsList,
      "type": _vm.modeltype
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73e14e10"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeTopNav/HomeTopNav.vue
// module id = 581
// module chunks = 0